module.exports = __webpack_public_path__ + "static/media/AnaPaula_Monsalve_Front(1).dc5d3cfa.pdf";